import { useState, useEffect } from "react";
import { Radio } from "lucide-react";
import { BoardCard } from "@/components/board/BoardCard";
import { api } from "@/lib/api";

const LOGO = "https://customer-assets-jai6qajn.emergentagent.net/job_novemberkasan-live/artifacts/wbdnhihh_Novemberkasan_Logotyp.png";

export default function AnslagstavlaLive() {
  const [posts, setPosts] = useState([]);
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    let alive = true;
    const load = () => api.boardPosts().then((d) => { if (alive) setPosts(d); }).catch(() => {});
    load();
    const t = setInterval(load, 10000);
    const c = setInterval(() => setNow(new Date()), 1000);
    return () => { alive = false; clearInterval(t); clearInterval(c); };
  }, []);

  return (
    <div className="min-h-screen bg-[#0B0C0E]" data-testid="board-live">
      <header className="sticky top-0 z-10 flex items-center justify-between gap-4 border-b border-white/10 bg-[#0B0C0E]/95 px-6 sm:px-10 py-4 backdrop-blur">
        <div className="flex items-center gap-4">
          <img src={LOGO} alt="Novemberkåsan" className="h-14 w-auto" />
          <div>
            <div className="font-display text-2xl sm:text-3xl font-black uppercase text-white leading-none">Anslagstavla</div>
            <div className="font-mono text-[11px] uppercase tracking-widest text-white/40">Novemberkåsan 2026 · Knivsta</div>
          </div>
        </div>
        <div className="flex items-center gap-5">
          <span className="inline-flex items-center gap-2 rounded-full bg-red-600 px-4 py-2 font-mono text-sm font-bold uppercase tracking-wide text-white">
            <Radio className="w-4 h-4 pulse-dot" /> Live
          </span>
          <span className="font-mono text-3xl sm:text-4xl font-bold tabular-nums text-amber-500">{now.toLocaleTimeString("sv-SE", { hour: "2-digit", minute: "2-digit" })}</span>
        </div>
      </header>
      <main className="px-6 sm:px-10 py-8">
        {posts.length === 0 ? (
          <div className="grid place-items-center py-32 text-center">
            <div>
              <div className="font-display text-4xl font-black uppercase text-white/30">Inga anslag ännu</div>
              <p className="mt-3 font-mono text-sm uppercase tracking-widest text-white/25">Information publiceras löpande under tävlingen</p>
            </div>
          </div>
        ) : (
          <div className="columns-1 md:columns-2 xl:columns-3 gap-6" data-testid="board-live-grid">
            {posts.map((p) => <BoardCard key={p.id} post={p} big />)}
          </div>
        )}
      </main>
    </div>
  );
}
